var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{query: {..._vm.$route.query, api: undefined, offset: undefined}}}},[_vm._t("default",function(){return [_vm._v("Show all")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }